/* eslint-disable no-unused-vars */
import React from "react";
import { ScalableImage, Typography } from "design_system/src";

export const ImmersiveFooter: React.FC = () => {
  return (
    <footer className="bg_neutral_900">
      <div className="dso_container">
        <div className="m_y_sm">
          <div className="display_flex flex_align_center flex_gap_lg h_40_px">
            <div className="border_r_solid border_neutral_700 border_1 p_r_lg h_100_per w_50_per_mobile">
              <ScalableImage
                src="https://ik.imagekit.io/ozon/Compartidos/Logos/logo_ozon_blanco"
                desktopWidth={10}
                mobileWidth={5}
                className="img_contain"
                alt="Logo Ozon – Plataforma de financiamiento de motos nuevas y seminuevas en CDMX"
              />
            </div>
            <Typography
              scale="small"
              scaleMobile="xsmall"
              weight="600"
            >
              Con respaldo de
            </Typography>
            <div className="h_100_per" style={{ maxWidth: "40px" }}>
              <ScalableImage
                src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_hecho_en_mexico"
                className="img_contain"
                alt="Logotipo oficial Hecho en México con un águila estilizada"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>

  );
};
